// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__O5CKM","requiredAsterisk":"Info_requiredAsterisk__372BZ"};